'use strict';

module.exports = rtfToHTML;

function outputTemplate(doc, defaults, content) {
  return "<!DOCTYPE html>\n<html>\n  <head>\n    <meta charset=\"UTF-8\">\n    <style>\n    body {\n      margin-left: ".concat(doc.marginLeft / 20, "pt;\n      margin-right: ").concat(doc.marginRight / 20, "pt;\n      margin-top: ").concat(doc.marginTop / 20, "pt;\n      margin-bottom: ").concat(doc.marginBottom / 20, "pt;\n      font-size: ").concat(defaults.fontSize / 2, "pt;\n      text-indent: ").concat(defaults.firstLineIndent / 20, "pt;\n    }\n    </style>\n  </head>\n  <body>\n    ").concat(content.replace(/\n/, '\n    '), "\n  </body>\n</html>\n");
}

function rtfToHTML(doc, options) {
  var defaults = Object.assign({
    font: doc.style.font || {
      name: 'Times',
      family: 'roman'
    },
    fontSize: doc.style.fontSize || 24,
    bold: false,
    italic: false,
    underline: false,
    strikethrough: false,
    foreground: {
      red: 0,
      blue: 0,
      green: 0
    },
    background: {
      red: 255,
      blue: 255,
      green: 255
    },
    firstLineIndent: doc.style.firstLineIndent || 0,
    indent: 0,
    align: 'left',
    valign: 'normal',
    paraBreaks: '\n\n',
    paraTag: 'p',
    template: outputTemplate
  }, options || {});
  var content = doc.content.map(function (para) {
    return renderPara(para, defaults);
  }).filter(function (html) {
    return html != null;
  }).join(defaults.paraBreaks);
  return defaults.template(doc, defaults, content);
}

function font(ft) {
  var name = ft.name.replace(/-\w+$/, '');
  var family = genericFontMap[ft.family];
  if (name === 'ZapfDingbatsITC') return '';
  return 'font-family: ' + name + (family ? ", ".concat(family) : '');
}

var genericFontMap = {
  roman: 'serif',
  swiss: 'sans-serif',
  script: 'cursive',
  decor: 'fantasy',
  modern: 'sans-serif',
  tech: 'monospace',
  bidi: 'serif'
};

function colorEq(aa, bb) {
  return aa.red === bb.red && aa.blue === bb.blue && aa.green === bb.green;
}

function CSS(chunk, defaults) {
  var css = '';

  if (chunk.style.foreground != null && !colorEq(chunk.style.foreground, defaults.foreground)) {
    css += "color: rgb(".concat(chunk.style.foreground.red, ", ").concat(chunk.style.foreground.green, ", ").concat(chunk.style.foreground.blue, ");");
  }

  if (chunk.style.background != null && !colorEq(chunk.style.background, defaults.background)) {
    css += "background-color: rgb(".concat(chunk.style.background.red, ", ").concat(chunk.style.background.green, ", ").concat(chunk.style.background.blue, ");");
  }

  if (chunk.style.firstLineIndent != null && chunk.style.firstLineIndent > 0 && chunk.style.firstLineIndent !== defaults.firstLineIndent) {
    css += "text-indent: ".concat(chunk.style.firstLineIndent / 20, "pt;");
  }

  if (chunk.style.indent != null && chunk.style.indent !== defaults.indent) {
    css += "padding-left: ".concat(chunk.style.indent / 20, "pt;");
  }

  if (chunk.style.align != null && chunk.style.align !== defaults.align) {
    css += "text-align: ".concat(chunk.style.align, ";");
  }

  if (chunk.style.fontSize != null && chunk.style.fontSize !== defaults.fontSize) {
    css += "font-size: ".concat(chunk.style.fontSize / 2, "pt;");
  }

  if (!defaults.disableFonts && chunk.style.font != null && chunk.style.font.name !== defaults.font.name) {
    css += font(chunk.style.font);
  }

  return css;
}

function styleTags(chunk, defaults) {
  var open = '';
  var close = '';

  if (chunk.style.italic != null && chunk.style.italic !== defaults.italic) {
    open += '<em>';
    close = '</em>' + close;
  }

  if (chunk.style.bold != null && chunk.style.bold !== defaults.bold) {
    open += '<strong>';
    close = '</strong>' + close;
  }

  if (chunk.style.strikethrough != null && chunk.style.strikethrough !== defaults.strikethrough) {
    open += '<s>';
    close = '</s>' + close;
  }

  if (chunk.style.underline != null && chunk.style.underline !== defaults.underline) {
    open += '<u>';
    close = '</u>' + close;
  }

  if (chunk.style.valign != null && chunk.style.valign !== defaults.valign) {
    if (chunk.style.valign === 'super') {
      open += '<sup>';
      close = '</sup>' + close;
    } else if (chunk.style.valign === 'sub') {
      open += '<sup>';
      close = '</sup>' + close;
    }
  }

  return {
    open: open,
    close: close
  };
}

function renderPara(para, defaults) {
  if (!para.content || para.content.length === 0) return;
  var style = CSS(para, defaults);
  var tags = styleTags(para, defaults);
  var pdefaults = Object.assign({}, defaults);

  for (var _i = 0, _Object$keys = Object.keys(para.style); _i < _Object$keys.length; _i++) {
    var item = _Object$keys[_i];
    if (para.style[item] != null) pdefaults[item] = para.style[item];
  }

  var paraTag = defaults.paraTag;
  return "<".concat(paraTag).concat(style ? ' style="' + style + '"' : '', ">").concat(tags.open).concat(para.content.map(function (span) {
    return renderSpan(span, pdefaults);
  }).join('')).concat(tags.close, "</").concat(paraTag, ">");
}

function renderSpan(span, defaults) {
  var style = CSS(span, defaults);
  var tags = styleTags(span, defaults);
  var value = "".concat(tags.open).concat(span.value).concat(tags.close);

  if (style) {
    return "<span style=\"".concat(style, "\">").concat(value, "</span>");
  } else {
    return value;
  }
}